import { Checkbox } from 'avo-ui'
import Search from 'components/commons/search'
import { capitalize } from 'utils/utils'
import { FixedSizeList as List } from 'react-window'
import { useEffect, useState } from 'react'
import clsx from 'clsx'

const CheckboxList = ({ className, classNameOptions, options, name, values, onChange, placeholder }) => {
    const [listOption, setListOption] = useState([])

    const onSearchList = (keyword) => {
        const filterList = options.filter((i) => i?.label?.toLowerCase().includes(keyword.toLowerCase()))
        setListOption(filterList)
    }

    const isChecked = (value) => [...values].includes(value)

    const checkedHandler = (item) => {
        let newData
        if (item?.checked) {
            newData = [...values]
            newData.push(item?.value)
        } else {
            newData = [...values]?.filter((i) => i !== item?.value)
        }
        if (onChange) onChange(newData)
    }

    const checkedAllHandler = (item) => {
        let newData = []
        if (item?.checked) {
            newData = [...options].map((i) => i?.value)
        }
        if (onChange) onChange(newData)
    }

    useEffect(() => {
        setListOption(options)
    }, [options])

    return (
        <div className={className}>
            <Search onSearch={onSearchList} placeholder={placeholder} />
            <div className={'-mt-2 pt-2 border-x border-b rounded-b-lg'}>
                <div className={'px-5 py-2 bg-blue-5'}>
                    {listOption.length ? (
                        <Checkbox
                            label={<div className={'capitalize'}>{`Select All ${name}`}</div>}
                            name={`select_all_${name}`}
                            value={'select_all'}
                            checked={options?.length === values?.length}
                            onChange={(value) => checkedAllHandler(value)}
                        />
                    ) : (
                        <div>Not Found</div>
                    )}
                </div>
                <List
                    className={clsx(listOption.length ? 'block' : 'hidden', classNameOptions)}
                    height={Math.min(listOption?.length * 40, 200)} // Maksimum tinggi
                    itemCount={listOption.length}
                    itemSize={40} // Tinggi setiap item
                    width='100%'
                >
                    {({ index, style }) => {
                        const item = listOption[index]
                        return (
                            <div className={'pt-2 px-5'} key={item.value} style={style}>
                                <Checkbox
                                    label={
                                        <div className={'flex items-center space-x-2'}>
                                            {item?.image_url && (
                                                <img
                                                    src={item?.image_url}
                                                    alt={item?.image_url}
                                                    className={'w-8 h-3.5'}
                                                />
                                            )}
                                            <p>{capitalize(item?.label)}</p>
                                        </div>
                                    }
                                    name={item?.name}
                                    value={item?.value}
                                    checked={isChecked(item?.value)}
                                    onChange={(value) => checkedHandler(value)}
                                />
                            </div>
                        )
                    }}
                </List>
            </div>
        </div>
    )
}

export default CheckboxList
